module.exports = __webpack_public_path__ + "68b0968e9b47606f307b9d9cdd688912.svg";